import { ApiCallsFactory, LocalPersistence } from './../factories/index';

// getting the session data
const getSession = async () => {
  const get_session = new LocalPersistence('session')
  const session = await get_session.getSessionPersistence()
  return session || {}
}

// getCall
const getHelper = async(
  url: string,
) => {
  const currentSession = await getSession() || {}
  const getService = new ApiCallsFactory(`${url}?supplier=${currentSession?.supplier}&propertyid=${currentSession?.propertyId}`,currentSession?.token)
  const response = await getService.getData()
  return response
}

// put call
const putHelper = async(
  url: string,
  body: object
) => {
try {
  const currentSession = await getSession() || {}
  const putBody = {
    ...body,
    supplier: currentSession?.supplier,
    propertyId: currentSession?.propertyId,
  }
  const putService = new ApiCallsFactory(url, currentSession.token, putBody)
  const response = await putService.putData()
  return response
  } catch (error: any) {
    return error
  }
}

const postHelper = async(
  url: string,
  body: object
  ) => {
  try {
    const currentSession = await getSession()
    const postBody = {
      ...body,
      supplier: currentSession.supplier,
      propertyId: currentSession.propertyId,
    }
    const postService = new ApiCallsFactory(url, currentSession.token, postBody)
    const response = await postService.postData()
    return response
  } catch (error: any) {
    return error
  }
}

export {
  putHelper,
  getHelper,
  postHelper
}
